import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import { useUIStore } from '@/lib/store/uiStore';
import Sidebar from '../sidebar/Sidebar';
import { Menu } from 'lucide-react';
import { Button } from '../ui/button';

function AppLayout() {
  const { isSidebarOpen, isMobile, setIsMobile, toggleSidebar } = useUIStore();

  // Detect mobile on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, [setIsMobile]);

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      {/* Sidebar */}
      <div
        className={`
          transition-transform duration-300 ease-in-out
          border-r border-gray-200
          ${isMobile ? 'fixed inset-y-0 left-0 z-50 w-full' : 'relative w-64'}
          ${isMobile && !isSidebarOpen && '-translate-x-full'}
        `}
      >
        <Sidebar />
      </div>

      {/* Mobile overlay */}
      {isMobile && isSidebarOpen && (
        <div
          className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm z-40"
          onClick={toggleSidebar}
        />
      )}

      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Mobile header */}
        {isMobile && (
          <div className="border-b border-gray-200 bg-card p-4 flex items-center shadow-sm">
            <Button
              variant="ghost"
              size="icon"
              onClick={toggleSidebar}
              className="mr-2"
            >
              <Menu className="h-5 w-5" />
            </Button>
            <h1 className="text-lg font-semibold text-foreground">Multi AI Chat</h1>
          </div>
        )}

        <main className="flex-1 overflow-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default AppLayout;
